import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FormFieldWrapper } from '../FormFieldWrapper';
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';

interface FormDatePickerProps extends FieldRenderProps {
  includeTime?: boolean;
  isLoading?: boolean;
}

export const FormDatePicker: React.FC<FormDatePickerProps> = fieldRenderProps => {
  const { includeTime, name, value, onChange, disabled, isLoading } = fieldRenderProps;

  const dateValue =
    value !== undefined && value !== null && value !== '' ? (value instanceof Date ? value : new Date(value)) : null;

  const pickerKey = value === null || value === undefined || value === '' ? Date.now() : 'picker';

  const popupSettings = {
    popupClass: 'form-date-picker-popup',
    collision: {
      horizontal: 'flip' as const,
      vertical: 'flip' as const
    },
    animate: true
  };

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      {includeTime ? (
        <DateTimePicker key={pickerKey} name={name} value={dateValue} onChange={onChange} disabled={disabled} />
      ) : (
        <DatePicker
          key={pickerKey}
          name={name}
          value={dateValue}
          onChange={onChange}
          disabled={disabled}
          popupSettings={popupSettings}
        />
      )}
    </FormFieldWrapper>
  );
};
